export const EstablishmentTypes = {
  Text: 1,
  Checkbox: 2,
  Option: 3,
  Date: 4,
  DateTime: 5,
};

export const SubQuestionTypes = {
  Text: 1,
};

export interface SubQuestion {
  id: number | string;
  fieldName: string;
  fieldType: number | string;
  isRequired: boolean;
  name?: string;
}

export interface CheckboxQuestions {
  id: number | string;
  name: "true" | "false";
  subQuestion: SubQuestion[];
}
